import { createFileRoute } from '@tanstack/react-router';

// The Connections tab content is populated in a later PR of the integrations-directory migration.
function IntegrationsOverviewRoute() {
  return null;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/all/overview')({
  component: IntegrationsOverviewRoute,
});
